import React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

import Carousel from "../../Carousel";
import Image from "../../Image";
import ListOptions from "../../List/Activities/options";
import Policies from "../../Policies";

import StringParser from "../../../utils/StringParser";

import IntlMessage from "../../../LocaleEngine";

export default function CellActivitiesDetails(props) {
  const { index, element, showImages = true } = props;

  const addToCart = (element, amount, callback, amountOfDays) => {
    props.addToCart(element, amount, callback, amountOfDays);
  };

  function createMarkup(text) {
    return { __html: text };
  }

  let arrayComponents = [
    <div className="tabPane">
      <ListOptions
        componentName={props.componentName}
        packageCart={props.packageCart}
        addQuantity={props.addQuantity}
        reduceQuantity={props.reduceQuantity}
        quantityPicker={props.quantityPicker}
        minQuantity={props.minQuantity}
        maxQuantity={props.maxQuantity}
        dateOfActivity={props.dateOfActivity}
        isPackage={props.isPackage}
        displayType={props.displayType}
        loading={props.loading}
        configuration={props.configuration}
        compact={props.compact}
        addToCart={addToCart.bind(this)}
        list={element.ProductList}
        productCategoryId={props.productCategoryId}
      />
    </div>,
    <div className="tabPane">
      <React.Fragment>
        <h3>
          <IntlMessage id="activities.cell.description.product_description" />
        </h3>
        <Typography variant="body1" gutterBottom>
          <span
            dangerouslySetInnerHTML={createMarkup(
              StringParser(element.Description)
            )}
          />
        </Typography>
      </React.Fragment>
      {element.Fulfillment !== "" ? (
        <React.Fragment>
          <h3>
            <IntlMessage id="activities.cell.description.fulfillment" />
          </h3>
          <Typography variant="body1" gutterBottom>
            <span
              dangerouslySetInnerHTML={createMarkup(
                StringParser(element.Fulfillment)
              )}
            />
          </Typography>
        </React.Fragment>
      ) : null}
    </div>,
    <div className="tabPane">
      <Carousel>
        {element.Images
          ? element.Images.map((img, index) => {
              return (
                <React.Fragment key={"roomImg_ " + index}>
                  {img.ImageCaption ? (
                    <div className="caption">{img.ImageCaption}</div>
                  ) : null}
                  <Image
                    source={img.Delivery.large + img.FileName}
                    alt={element.ProductName}
                  />
                </React.Fragment>
              );
            })
          : null}
      </Carousel>
    </div>,
    <div className="tabPane">
      <Policies element={element.Policies} />
    </div>,
    <div className="tabPane">
      <iframe
        title={element.ProductName}
        className={"customMap"}
        src={element.customMap}
      />
    </div>,
  ];
  return (
    <Grid
      key={index + "cell-details"}
      item
      xs={12}
      className="item activitiesDetails"
    >
      <div className="tabWrapper">
        <AppBar position="static" className="tabBar">
          <Tabs
            className="tabsMenu"
            value={props.value}
            onChange={props.handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollbuttons="on"
          >
            <Tab
              value={0}
              className="tabOption"
              label={<IntlMessage id="activities.cell.tabs.options" />}
            />
            {((props &&
              props.configuration &&
              props.configuration.config &&
              props.configuration.config.hideDescriptionTab !== true) ||
              window.innerWidth <= 991) && (
              <Tab
                value={1}
                className="tabOption"
                label={<IntlMessage id="activities.cell.tabs.description" />}
              />
            )}
            {element.Images && showImages ? (
              <Tab
                value={2}
                className="tabOption"
                label={<IntlMessage id="activities.cell.tabs.photos" />}
              />
            ) : null}
            {element.Policies && element.Policies.length > 0 ? (
              <Tab
                value={3}
                className="tabOption"
                label={<IntlMessage id="activities.cell.tabs.policies" />}
              />
            ) : null}
            {element.customMap && (
              <Tab
                value={4}
                className="tabOption"
                label={<IntlMessage id="lodging.location.location" />}
              />
            )}
          </Tabs>
        </AppBar>
        <div className="tabPanes">{arrayComponents[props.value]}</div>
      </div>
    </Grid>
  );
}
